import React, { useEffect, useState } from 'react';
import './VehiclesPage.scss';
import * as ReactDOM from 'react-dom';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useSearchParams } from 'react-router';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import Pagination from '../../../components/base/Pagination/Pagination';
import TooltipWithPortal from '../../../components/base/Tooltip/TooltipWithPortal';
import {
  getFilterData, getPaginationOpts, responseLogWithNotification, useUpdatePeriod,
} from '../../../utils/utils';
import { VISITS_MODULE } from '../../../configs/moduleNames';
import getDefaultDataRange from '../../../utils/getDefaultDataRange';
import { getSystemData } from '../../System/reducer';
import FilterRow from '../../../components/base/FilterRow/FilterRow';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import TextInput from '../../../components/fields/TextInput/TextInput';
import { TravelHistoryFilter } from './TravelHistoryFilter';
import { loadVisitsList } from '../../Visits/actions';
import { getVisitData } from '../../Visits/reducer';
import { visitColumns } from '../../Visits/components/visitsColumns';
import getDefaultSort from '../../../utils/getDefaultSort';
import TimerLoader from '../../../components/base/Loader/TimerLoader';
import TextSearchInput from '../../../components/fields/TextInput/TextSearchInput';

export default function TravelHistoryDialog({ id, handleClose = () => {} }) {
  const pageName = 'travel-history-dialog';
  const filterName = `${pageName}-filter`;
  const { updatePeriod } = useSelector(getSystemData);
  const [searchParams, setSearchParams] = useSearchParams();
  const vehicle_id = searchParams.get('vehicle_id');
  const vehicle_lpn = searchParams.get('vehicle_lpn');
  const {
    visitList,
    visitListMeta,
    loadingVisitsList,
  } = useSelector(getVisitData);

  const dispatch = useDispatch();
  const store = useStore();
  const [isOpenFilter, setOpenFilter] = useState(false);

  const loadData = opts => {
    const paginationOpts = getPaginationOpts(store.getState()[VISITS_MODULE].visitListMeta, opts);
    const requestData = {
      id: id || vehicle_id,
      ...paginationOpts,
      filter: { vehicle_id, ...getValues() },
    };
    const p1 = dispatch(loadVisitsList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };

  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);
  const defaultDate = getDefaultDataRange();
  const defaultFilterValues = { };
  useEffect(() => reset(getFilterData(filterName, defaultFilterValues)), []);
  const {
    getValues, watch, control, reset, setValue,
  } = useForm({ defaultValues: getFilterData(filterName, defaultFilterValues) });
  useEffect(() => {
    const subscription = watch(values => {
      localStorage.setItem(filterName, JSON.stringify(values));
      loadData({ page: 1 });
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const handleEdit = () => {};

  const [sort, setSort] = useState(getDefaultSort(visitColumns));

  const changeSort = fieldName => {
    if (sort && (sort === fieldName || sort === `-${fieldName}`)) {
      if (sort === `-${fieldName}`) {
        setSort(fieldName);
      } else if (sort === fieldName) {
        setSort('');
      }
    } else {
      setSort(`-${fieldName}`);
    }
  };

  useEffect(() => { loadData(); }, [sort]);

  function HeaderInfo() {
    const headerInfoBlock = document.getElementById('header-info-block');
    return headerInfoBlock ? (ReactDOM.createPortal(
      <div className="sub-page-header">
        <div className="breadcrumbs">
          {/* <span className="breadcrumbs-prev" onClick={handleClose}>Просмотр информации о М678РР57</span> */}
          <span className="breadcrumbs-prev" onClick={handleClose}>Просмотр информации о {vehicle_lpn || ''}</span>
          <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
          <span className="breadcrumbs-current">История поездок</span>
        </div>
      </div>,
      headerInfoBlock,
    )
    ) : null;
  }

  const renderContextMenu = item => (
    <div className="more-wrapper">
      {/* <Button variant="link" className="w-100 more-button" onClick={handleShow(item)}> */}
      {/*  Просмотр */}
      {/* </Button> */}
      {/* <Button variant="link" className="w-100 more-button" onClick={handleEdit(item)}> */}
      {/*  Редактировать */}
      {/* </Button> */}
    </div>
  );

  const moreFormatter = (_, item) => (
    <TooltipWithPortal
      content={<Icons customIcon icon="more-vert" className="more-vert" />}
      classNamePortal="more-actions"
      tooltipContent={renderContextMenu(item)}
      classNameWrapper="more-tooltip-wrapper"
      className="more-tooltip"
    />
  );

  return (
    <div className="sub-page-dialog travel-history-dialog">
      <TimerLoader global loading={loadingVisitsList} />
      <HeaderInfo />
      <div className="page sub-page-container">
        <div className="page-title">
          <div className="title-text">История поездок</div>
          <FilterRow>
            <FieldDTO
              control={control}
              component={TextSearchInput}
              dtoObject={{
                name: 'search',
                type: String,
                labelKey: 'search',
              }}
              className="no-border"
            />
            <div className="filter-sep" />
            <Button variant="second" onClick={() => setOpenFilter(true)}>
              <Icons customIcon className="file-download" width={24} height={24} icon="filter" />
            </Button>
            {isOpenFilter
              ? (
                <TravelHistoryFilter
                  control={control}
                  onHide={() => {
                    setOpenFilter(false);
                  }}
                  getValues={getValues}
                  setValue={setValue}
                  reset={reset}
                  defaultValues={defaultFilterValues}
                  meta={visitListMeta}
                />
              )
              : null}
          </FilterRow>
        </div>
        <div className="page-content-wrapper">
          <div className="page-content">
            <div className="grid-wrapper frame">
              <div className="custom-scroll-theme sticky-table-wrapper">
                <CustomizedGrid
                  key={pageName}
                  // onDoubleClickByRow={(item, event) => handleShow(item)(event)}
                  data={visitList}
                  columns={visitColumns.filter(item => item?.sortField !== 'vehicle.vehicle_lpn')}
                  name={`${pageName}-list`}
                  settingsFormatter={moreFormatter}
                  renderContextMenu={renderContextMenu}
                  changeSort={changeSort}
                  sort={sort}
                />
              </div>
            </div>
            <Pagination meta={visitListMeta} list={visitList} handleChangeMeta={loadData} />
          </div>
        </div>
      </div>
    </div>
  );
}
